import clsx from 'clsx'
import React from 'react'
import { chaseHeadingData } from './chase-list-components/chase-list-data'
import SkeltonTableRow from './skelton/skelton-table-row'
import NoItem from './no-item'

interface ITableWrapper {
    children: React.ReactNode
    headingData: typeof chaseHeadingData,
    additionalClasses?: string
    isLoading?: boolean
    totalCount?: number
}

const TableWrapper: React.FC<ITableWrapper> = ({ children, headingData, additionalClasses, isLoading, totalCount }) => {
    return (
        <>
            <table
                className={clsx("table-auto h-max w-full text-left smallTablet:min-w-[880px]", additionalClasses)}
            >
                <thead>
                    <tr>
                        {headingData.map((data, index) => (
                            <th
                                key={index}
                                className={clsx(
                                    "sticky top-0 z-10 bg-surface uppercase text-light-gray font-semibold text-[10px] tracking-[0.08em] py-3 border-b border-edge first:pl-1",
                                    data.align === "center" && "text-center",
                                    data.align === "right" && "text-right"
                                )}
                            >
                                {data.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? <SkeltonTableRow /> : children}
                </tbody>
            </table>
            {(totalCount === 0 && !isLoading) && <NoItem />}
        </>
    )
}

export default TableWrapper
